import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import DetailsHeaderBar from "../components/DetailsHeaderBar";
import DetailsTopBar from "../components/DetailsTopBar";
import WalletDetails from "../components/WalletDetails";
import cash from "../assets/images/tc-cash-wallet 1.png";
import units from "../assets/images/tc-units-wallet 2.png";
import mini from "../assets/images/tcuk_agent_wallet 2.png";
import wallet2 from '../assets/images/Wallet03.1 1.png';
import wallet1 from '../assets/images/Wallet01 5.png';
import dollarY from '../assets/images/Dollar Bag (1).png';
import dollarG from '../assets/images/Dollar Bag.png';
import history1 from '../assets/images/Group 37483.png';
import oldbank from '../assets/images/bank-pound-icon2 4.png';
import gift from '../assets/images/Gift.png';
import "../styles/AdvertisingAgentWallet.css";

function AdvertisingAgentWallet() {
  const location = useLocation();
  const agent = location.state?.agent;
  const navigate = useNavigate();

  if (!agent) {
    return <p style={{ padding: "30px" }}>No more data available.</p>;
  }

  // Extract wallet data from the nested structure
  const agentWalletBalance =
    agent.agent_wallet_details?.points ||
    agent.agent_details?.wallet_balance ||
    agent.agent_wallet_points ||
    agent.wallet_details?.agent_wallet?.points ||
    0;

  const customerWalletBalance =
    agent.customer_details?.wallet_details?.total_points ||
    agent.customer_wallet_points ||
    agent.wallet_details?.total_points ||
    0;

  const earnedBonusCash =
    agent.wallet_details?.earned_bonus_reward_wallet?.cash || 0;

  const primaryWalletBalance =
    agent.customer_details?.wallet_details?.primary_wallet?.points ||
    agent.wallet_details?.primary_wallet?.points ||
    0;

  // Define all possible tabs
  const allTabs = [
    {
      key: "personal",
      label: "Personal Details",
      path: "/business-agent-details",
    },
    {
      key: "wallet",
      label: "Wallet Details",
      path: "/business-agent-wallet-details",
    },
    {
      key: "invitation",
      label: "Invitation Details",
      path: "/business-agent-invitation-details",
      showWhen: "approved",
    },
    {
      key: "request",
      label: "Request Details",
      path: "/business-agent-request-history",
    },
  ];

  // Filter tabs based on status
  const getTabsByStatus = (agentStatus) => {
    return allTabs.filter((tab) => {
      if (!tab.showWhen) return true; // Always show tabs without conditions
      return tab.showWhen === agentStatus;
    });
  };

  // Usage
  const tabs = getTabsByStatus(agent.status);

  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
          title="Business Ads Agent Details"
          subtitle="You can edit your details to update your profile"
          breadcrumbs={[
            { label: "Home", path: "/dashboard" },
            {
              label: "Manage Business Ads Agent",
              path: "/manage-business-agent",
            },
            { label: "Business Ads Agent Details" },
          ]}
        />
        <DetailsTopBar tabs={tabs} activeTab="wallet" agent={agent} />
        <div className="wallet-section">
          {/* FIRST WALLET FULL WIDTH - AGENT WALLET (Only show if agent is approved) */}
          {agent.status === "approved" && (
              <WalletDetails
                imgH={wallet1}
                imgT={gift}
                imgHi={history1}
                title="Business Agent TopCoin Wallet (Network)"
                amount={`${agentWalletBalance} TopCoin`}
                subText="Available TopCoin"
                bgColor="#eff6ff"
                bgColor1="#dbeafe"
                historyLink="/business-agent-transaction"
                stateData={{ agent }}
              />
          )}

          {/* TWO WALLETS SIDE BY SIDE - CUSTOMER WALLETS */}
            <WalletDetails
              imgH={wallet2}
              imgT={dollarG}
              imgHi={history1}
              title="TopCoin Wallet (Retail)"
              amount={`${customerWalletBalance} TopCoin`}
              subText="Available TopCoin"
              bgColor="#f0fdf4"
              bgColor1="#dcfce7"
              historyLink="/business-agent-transaction-history"
              stateData={{ agent }}
            />

            <WalletDetails
              imgH={wallet1}
              imgT={dollarY}
              imgHi={history1}
              title="Earned Bonus Reward Wallet (Retail)"
              amount={`£ ${earnedBonusCash}`}
              subText="Available Cash"
              bgColor="#fff7ed"
              bgColor1="#ffedd5"
              showButton={false}
            />

            <WalletDetails
              imgH={oldbank}
              imgT={dollarY}
              title="Withdraw"
              amount={`£ ${(0).toFixed(2)}`}
              subText="Available Cash"
              bgColor="#f5f5f5"
              bgColor1="#e0e0e0"
              buttonText="Withdraw"
              disabled={true}
              showButton={true}
            />
        </div>
      </div>
    </div>
  );
}

export default AdvertisingAgentWallet;
